"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiTabs = getMuiTabs;
function getMuiTabs() {
  return {
    styleOverrides: {
      scroller: function () {
        return {
          alignItems: 'center',
          display: 'flex',
          height: '100%'
        };
      }
    }
  };
}